"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _UserListItem = _interopRequireDefault(require("./UserListItem"));
var _UserPicker = _interopRequireDefault(require("./UserPicker.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// COMPONENTS

// ASSETS

var UserPicker = function UserPicker(_ref) {
  var _ref$users = _ref.users,
    users = _ref$users === void 0 ? [] : _ref$users,
    _ref$selectedUserIds = _ref.selectedUserIds,
    selectedUserIds = _ref$selectedUserIds === void 0 ? [] : _ref$selectedUserIds,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    style = _ref.style,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? '' : _ref$mode,
    _ref$listItemClasses = _ref.listItemClasses,
    listItemClasses = _ref$listItemClasses === void 0 ? '' : _ref$listItemClasses;
  // HOOKS
  var classes = (0, _UserPicker.default)(style);
  if (disabled) return null;
  return /*#__PURE__*/_react.default.createElement(_core.List, {
    className: classes.listRoot,
    component: "nav",
    "data-testid": "users-items",
    key: "user-list-items"
  }, users.map(function (user) {
    var selected = selectedUserIds.includes(user.id);
    var key = "".concat(user.id, "-").concat(selected);
    return /*#__PURE__*/_react.default.createElement(_UserListItem.default, {
      user: user,
      selected: selected,
      onClick: onClick,
      key: key,
      mode: mode,
      listItemClasses: listItemClasses
    });
  }));
};
var _default = UserPicker;
exports.default = _default;